import { STATUS_COLOR, STATUS_ICON } from '@/components/Affectations/affectation.utils';
import type { Affectation } from '@/models/types';
import { Badge } from '@mantine/core';
import { useTranslate } from '@tolgee/react';

type Props = {
  status: Affectation['status'];
};

const AffectationStatusBadge = ({ status }: Props) => {
  const { t } = useTranslate();
  const Icon = STATUS_ICON[status];

  return (
    <Badge color={STATUS_COLOR[status]} variant="light" leftSection={<Icon size={12} />}>
      {t(`profil.affectations.status.${status}`)}
    </Badge>
  );
};

export default AffectationStatusBadge;
